import { Injectable } from '@angular/core';

@Injectable()
export class Helper {

  toCamelCase(value: string) {
    const expr = /([A-Z]*)([A-Z])([^\.\n]+)/gm;
    return value.replace(expr, (m, p1: string, p2: string, p3: string) => {
      if (p1.length > 0) {
        p1 = p1.toLowerCase();
      } else {
        p2 = p2.toLowerCase();
      }
      return p1 + p2 + p3;
    });
  }

  toResourceKey(value: string) {
    value = value.replace(/[\(\)\&\/\-]/gi, ' ');
    if (value[0] === value[0].toUpperCase()) {
      value = this.toCamelCase(value);
    }
    if (value.endsWith('.name')) {
      value = value.slice(0, -5);
    }
    const path = value.split('.');
    value = path.slice(path.length - 1).join('.');
    if (value === 'id') {
      value = path.slice(path.length - 2).join('.');
    }
    if (value === 'year' || value === 'month') {
      value = path.join('.');
    }
    const expr = /([A-Z]{2,})|(?=[A-Z]{1})(?![A-Z]{1}\.)|(\s)|(\d+)|\.|name$|Name$/;
    return value.split(expr).filter(s => s && s.trim().length > 0).map(s => s.trim().toUpperCase()).join('_');
  }

  /**
   * Converts the first letter of a string to lowercase.
   * Ex.: 'MyOnlyParameter-LaLahLah' becomes 'myOnlyParameter-LaLahLah'
   * @param str a string
   * @returns a converted string
   */
  firstLetterToLowerCase(str: string): string {
    return str[0].toLocaleLowerCase() + str.substring(1);
  }
  /**
   * Converts the first letter of all substrings - words splitted by '.' - to lowercase
   * Ex.: 'ThatsMYObject.OneArrayHere.HereComesMyProperty' becomes 'thatsMYObject.oneArrayHere.hereComesMyProperty'
   * @param str a string, containing properties split by '.'
   * @returns a converted string
   */
  allFirstLettersToLowerCase(str: string) {
    return str.split('.').map(this.firstLetterToLowerCase).join('.');
  }

  /**
   * Converts a string to camelCase. Beware it removes SPACES.
   * @param str
   * @returns
   * Source: https://stackoverflow.com/questions/2970525/converting-any-string-into-camel-case?page=1&tab=scoredesc#tab-top
   */
  convertStringToCamelCase(str: string) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
  }

  /** Get a nested property from an object without returning any errors.
   * If the property or property chain doesn't exist, undefined is returned.
   * Property names with spaces may use either dot or bracket "[]" notation.
   * Note that bracketed property names without surrounding quotes will fail the lookup.
   *      e.g. embedded variables are not supported.
   * @param {object} obj The object to check
   * @param {string} prop The property or property chain to get (e.g. obj.prop1.prop1a or obj['prop1'].prop2)
   * @returns {*|undefined} The value of the objects property or undefined if the property doesn't exist
   * Source: https://it.knightnet.org.uk/kb/node-js/get-properties/
   */
  getPropertyValueFromJson(obj, prop: string) {
    // Replace [] notation with dot notation
    prop = prop.replace(/\[['`](.*)['`]\]/g, '.$1');

    return prop.split('.').reduce(function (prev, curr) {
      return prev ? prev[curr] : undefined
    }, obj || self)
  }

  /**
   * Converts a UTC date to string, with local time.
   * @param date Date string in ISO format "yyyy-mm-ddThh:mi:ss", but WITHOUT the Z. Ex.: 2022-08-04T13:44:32. We'll add a 'Z' at the end.
   * @param locale String representing a locale, like 'pt-br', 'en-us', 'es-es'
   * @returns string with date formatted (pt-br style)
   */
  convertBadUTCDateToLocalDate(date: string, locale = 'pt-br') {
    /// Gambiarra notes: dates in RI api are coming in ISO format, without the Z. In js standard, this would mean that they are already in local time.
    ///  However, in some specific cases, like Service Note Requests (SNR), dates are stored as UTC.
    ///  When those SNR dates come in the json, from the api, they are without the 'Z' in the end, but they need to be converted to local time.

    // TODO: we should check if date is in "our" valid ISO date format "yyyy-mm-ddThh:mi:ss"
    const newDate = new Date(date + 'Z');

    // _options example taken from https://stackoverflow.com/questions/2388115/get-locale-short-date-format-using-javascript
    const _options = {
      // weekday: 'short',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };

    return newDate.toLocaleString(locale, _options);
  }

  public getMonth2Digits(date) {
    const month = date.getMonth() + 1;
    if (month < 10) {
      return '0' + month;
    }
    return month;
  }

  public getDay2Digits(date) {
    const day = date.getDate();
    if (day < 10) {
      return '0' + day;
    }
    return day;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/helpers/helper.ts